var React = require('react');

function LineDesktop1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 1H219C257.66 1 289 32.3401 289 71V97C289 135.66 320.34 167 359 167H542","stroke":"white","strokeWidth":"2"}));
}

LineDesktop1.defaultProps = {"width":"542","height":"168","viewBox":"0 0 542 168","fill":"none"};

module.exports = LineDesktop1;

LineDesktop1.default = LineDesktop1;
